import { Typography } from "@mui/material";

export const MuiTypography = Typography;
